import { render, staticRenderFns } from "./cebsbInfo_user_bindSchoolData.vue?vue&type=template&id=6303565f&scoped=true&"
import script from "./cebsbInfo_user_bindSchoolData.vue?vue&type=script&lang=js&"
export * from "./cebsbInfo_user_bindSchoolData.vue?vue&type=script&lang=js&"
import style0 from "./cebsbInfo_user_bindSchoolData.vue?vue&type=style&index=0&id=6303565f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6303565f",
  null
  
)

export default component.exports